import { Contact as ContactSection } from '../components/Contact/Contact';

export function Contact() {
  return (
    <main>
      <ContactSection />
    </main>
  );
} 